/* ==========================================================================
   Feel · FAQ Page — Tabs + Live Search + Sticky Tabs
   Source: _mockups/01_ALL_HTML_MOCKUPS/faq.html
   Loaded by: sections/feel-faq.liquid
   ========================================================================== */

(function () {
  'use strict';

  /* ===== TABS ===== */
  var tabs    = document.querySelectorAll('[data-faq-tab]');
  var panels  = document.querySelectorAll('[data-faq-panel]');
  var tabsNav = document.querySelector('.faq-tabs');

  tabs.forEach(function (tab) {
    tab.addEventListener('click', function () {
      var target = tab.dataset.faqTab;
      tabs.forEach(function (t) {
        t.dataset.active = String(t.dataset.faqTab === target);
      });
      panels.forEach(function (p) {
        p.dataset.active = String(p.dataset.faqPanel === target);
      });
      // Clear any active search when switching tabs
      var input = document.querySelector('[data-faq-search-input]');
      if (input && input.value.trim()) {
        input.value = '';
        clearSearch();
      }
    });
  });

  /* ===== STICKY TABS — pin below actual header height ===== */
  if (tabsNav) {
    function setTabsTop() {
      var headerGroup = document.querySelector('.shopify-section-group-header-group');
      if (headerGroup) {
        tabsNav.style.top = headerGroup.offsetHeight + 'px';
      }
    }
    setTabsTop();
    window.addEventListener('resize', setTabsTop);
  }

  /* ===== LIVE SEARCH ===== */
  var searchInput  = document.querySelector('[data-faq-search-input]');
  var searchStatus = document.querySelector('[data-faq-search-status]');

  function clearSearch() {
    // restore panel display to tab-driven state
    panels.forEach(function (p) {
      p.style.display = '';
      p.querySelectorAll('.accordion-item').forEach(function (item) {
        item.style.display = '';
      });
    });
    // restore tabs nav opacity
    if (tabsNav) tabsNav.style.opacity = '';
    // hide status
    if (searchStatus) {
      searchStatus.hidden = true;
      searchStatus.textContent = '';
    }
    // re-apply active panel visibility
    panels.forEach(function (p) {
      p.dataset.active = p.dataset.active; // force re-render via CSS
    });
  }

  function doSearch(query) {
    query = query.trim().toLowerCase();
    if (!query) {
      clearSearch();
      return;
    }

    // Dim tabs nav to signal search mode
    if (tabsNav) tabsNav.style.opacity = '0.4';

    var totalMatches = 0;

    panels.forEach(function (p) {
      var items = p.querySelectorAll('.accordion-item');
      var panelMatches = 0;

      items.forEach(function (item) {
        var summaryText = '';
        var summary = item.querySelector('summary');
        if (summary) summaryText = summary.textContent.toLowerCase();

        var bodyText = '';
        var body = item.querySelector('.accordion-body');
        if (body) bodyText = body.textContent.toLowerCase();

        var matches = summaryText.indexOf(query) !== -1 || bodyText.indexOf(query) !== -1;
        item.style.display = matches ? '' : 'none';
        if (matches) panelMatches++;
      });

      // Show panel if it has matches (override tab CSS)
      p.style.display = panelMatches > 0 ? 'block' : 'none';
      totalMatches += panelMatches;
    });

    if (searchStatus) {
      searchStatus.hidden = false;
      if (totalMatches === 0) {
        searchStatus.textContent = 'No results. Try a different word.';
      } else {
        searchStatus.textContent = totalMatches + ' result' + (totalMatches !== 1 ? 's' : '');
      }
    }
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      doSearch(searchInput.value);
    });

    // Clear on Escape
    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        searchInput.value = '';
        clearSearch();
        searchInput.blur();
      }
    });
  }

})();
